<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
import axios from '@/api/axios'
import {mapState} from 'vuex'
import {getItem, setItem} from '@/helpers/persistanceStorage'
import authApi from '@/api/auth'
import {mutationTypes as authMutations} from '@/store/modules/auth'

export default {
  mounted(){
    if(!this.permissions.length && getItem('token'))
      authApi.getCurrentUserPermissions()
          .then((response) => {
            this.$store.commit(authMutations.setPermissions, response.data)

          })

    if(!getItem('csrftoken')){
      axios.get('get-csrf-token/').then((response) => {
        setItem('csrftoken', response.data.csrftoken)
      })
    }
  },
  computed: {
    ...mapState({
      permissions: state => state.auth.permissions
    })
  },
}
</script>